import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";


const derivarMasivaTurnoSucursal = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${ENTITY_URL.DERIVACION.MASIVA_SUCURSAL}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default derivarMasivaTurnoSucursal;